import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CognitoService } from "src/app/core/services/cognito/cognito.service";
import { NotificationService } from "src/app/core/services/notification/notification.service";
import { RestCallService } from "src/app/core/services/rest-call/rest-call.service";
import { TranslateApplicationService } from "src/app/core/translate/translate-application-service";
import { ISuppliersIncomeTypes } from "../Interfaces/ISuppliersIncomeTypes";

@Injectable({
  providedIn: 'root',
})

export class SuppliersIncomeTypesService extends RestCallService {

  dataToSend: ISuppliersIncomeTypes = {
    pksupplierincometype: 0,
    supplierincometype: '',
    available: false,
    fksite: 0,
    username: ''
  }
  
  constructor(
		public httpClient: HttpClient,
		private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient,'JACSapi',toastr,notificationService,translate);
  }

  public GetSuppliersIncomeTypes() {
     if (!this.cognitoService.IsAuhtenticated())
       this.cognitoService.LogOut();
    
    this.dataToSend.fksite = Number(window.localStorage.getItem("pksite"));

    return this.post<ISuppliersIncomeTypes[]>('/api/SuppliersIncomeTypes/GetSuppliersIncomeTypes', this.dataToSend);
  }
}